import React, {Component} from 'react'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import Firebase from "firebase";

import {ImageUtils, CCUIUtils, Constants, DataActionTypes, CCButton, CCActions} from "./../../cc-imports";
import PropTypes from 'prop-types'
import CCErrorBoundary from "../../components/CCErrorBoundary/CCErrorBoundary";
import './../../styles/css/screens/SponsorDetails/sponsor-details.css'


class SponsorDetails extends Component {

    static propTypes = {
        sponsor: PropTypes.object,
        onViewRankPressed : PropTypes.func
    }

    static defaultProps = {
        onViewRankPressed : ()=>{}
    }

    constructor(props) {
        super(props)
        this.state = {}
        this._onSubmit = this._onSubmit.bind(this);
    }

    componentWillMount() {

    }

    componentDidMount() {

    }


    _validateAndSubmit() {


    }

    _onSubmit(reward) {
        Firebase.auth().currentUser.getIdToken(false).then((idToken) => {
            switch (reward.status) {
                case (Constants.rewardStatus.CREATED):
                    var updatedReward = this._updateReward(reward);
                    this.props.actions.claimReward({accessToken: idToken}, updatedReward, DataActionTypes.UPDATE);
                    break;
                case Constants.rewardStatus.CLAIMED:
                    var updatedReward = this._updateReward(reward);
                    this.props.actions.updateClaimReward({accessToken: idToken}, updatedReward, DataActionTypes.UPDATE);
                    break;
            }
        })
    }

    render() {
        let {sponsor, onViewRankPressed} = this.props;
        let {theme, promoDetails, name} = sponsor;
        console.log(theme, promoDetails)
        let user = this.props.user.user;
        var userPDetails;

        if(promoDetails){
            if(user){
                userPDetails = promoDetails[user.country] ? promoDetails[user.country] : promoDetails['ALL'];
            }
            else {
                userPDetails = promoDetails['ALL'];
            }
        }



        return (
            <CCErrorBoundary>
                <div>
                    <div className={"sponsor-container1"}>
                        <div>
                            {
                                (theme && theme.sGrpBannerImg) &&
                                <div className={"sponsor-container2"}>
                                    <img className={"sponsor-img"} resizeMode={'contain'} src={theme.sDetailsBannerImg}></img>
                                </div>
                            }
                        </div>
                        {
                            userPDetails &&
                            <div className={"sponsor-container3"}>
                                {
                                    userPDetails.map((pDetail, index) => {
                                        return (<h2 key={index} className={"sponsor-details"}>
                                            {CCUIUtils.getLocaleStr(pDetail)}
                                        </h2>)
                                    })
                                }
                            </div>
                        }
                        <div className={"rank-btn"}>
                        <CCButton onPress={onViewRankPressed} title={'View Your Ranks'}></CCButton>
                        </div>
                    </div>
                </div>
            </CCErrorBoundary>
        )
    }
}

export default connect(state => ({
    profile: state.profile,
    profileTabNavigation: state.profileTabNavigation,
    user: state.user,
    fireBaseUser: state.fireBaseUser,
    rewards: state.rewards
}), (dispatch) => ({
    actions: bindActionCreators({ ...CCActions}, dispatch),
    dispatch: dispatch
}))(SponsorDetails);



// WEBPACK FOOTER //
// ./src/app/screens/SponsorDetails/SponsorDetails.js